export default "__VITE_ASSET__b3513406__"